module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f9b8-1f3fb-200d-2642-fe0f.72b7eccc.svg";